import styled from 'styled-components';
import { spacing, body2 } from 'ui/theme';
import { WarningBanner, ErrorBanner } from 'ui/banner';
import { pxToRem } from 'utils/convert';

export const CatalogItemValueContainer = styled.div`
  &&& {
    .catalog-jsonViewerWrapper {
      /** conversion from a .css file */
      word-break: break-all;
      padding: ${pxToRem(10)};
      border: 1px solid #d6d6d6;
      border-radius: ${pxToRem(3)};
      min-height: ${pxToRem(100)};
    }
  }
`;

export const CSVPreviewContainer = styled.div`
  margin-top: ${spacing.base};
`;

export const CSVUploaderContainer = styled.div`
  &&& {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: ${spacing.double};
    > *:last-of-type {
      background-color: #fcfcfc; /** conversion from a .css file */
      flex: 1;
    }
    .catalog-progressBar {
      /** conversion from a .css file */
      height: unset;
      margin-top: 0;
      margin-bottom: 0;
    }
  }
`;

export const ModalActionsContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const ActionButtonContainer = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing.half};
  margin-left: auto;
`;

export const ModalHeaderContent = styled.div`
  display: flex;
  align-items: center;
  margin-right: ${spacing.double};
  justify-content: space-between;
  gap: ${spacing.base};
`;

export const ModalHeaderDescription = styled.div`
  ${body2}
`;

export const StyledWarningBanner = styled(WarningBanner)`
  margin-top: ${spacing.base};
  margin-bottom: ${spacing.base};
`;

export const StyledErrorBanner = styled(ErrorBanner)`
  margin-top: ${spacing.base};
  margin-bottom: ${spacing.base};
`;
